<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->
<div class="form-container" [ngStyle]="{ overflow: form.content?.type === 'COLLECTOR' ? 'visible' : '' }" [ngSwitch]="form.content?.type">
  <ptl-form-textbox
    *ngSwitchCase="'TEXTBOX'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-textbox>

  <ptl-form-connected-textbox
    *ngSwitchCase="'CONNECTED_TEXTBOX'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-connected-textbox>

  <ptl-form-question
    *ngSwitchCase="'QUESTION_FORM'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-question>

  <ptl-form-private-note
    *ngSwitchCase="'PRIVATE_NOTE'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-private-note>

  <ptl-form-file-upload
    *ngSwitchCase="'USER_FILE_UPLOAD'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-file-upload>

  <ptl-form-checkbox
    *ngSwitchCase="'CHECKBOX'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-checkbox>

  <ptl-quiz
    *ngSwitchCase="'QUIZ'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [quizContent]="form"
    (updateQuizContent)="onFormElementSaved($event)"
    (removeQuizContent)="onFormElementRemoved()"
  >
  </ptl-quiz>

  <ptl-collector
    *ngSwitchCase="'COLLECTOR'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (updateCollectorContent)="onFormElementSaved($event)"
    (removeCollectorContent)="onFormElementRemoved()"
  >
  </ptl-collector>

  <ptl-form-booking
    *ngSwitchCase="'BOOKING'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-booking>

  <ptl-form-portfolio
    *ngSwitchCase="'PORTFOLIO'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-portfolio>

  <ptl-form-project
    *ngSwitchCase="'PROJECT'"
    [id]="form.uid"
    [canRemoveItem]="canRemoveItem"
    [form]="form"
    (formElementAdded)="onFormElementSaved($event)"
    (formElementRemoved)="onFormElementRemoved()"
  >
  </ptl-form-project>
</div>
